export default __webpack_public_path__ + "static/media/About-01.be4aa352.gif";